import React from 'react';
import { useLens } from './LensContext';
import './LensToggle.css';

function LensToggle({ size = 'md' }) {
    const { lens, setLens } = useLens();
    const isBuilder = lens === 'builder';

    return (
        <div
            className={`lens-toggle lens-toggle--${size}`}
            role="group"
            aria-label="Choose how to view this portfolio"
        >
            <span
                className={`lens-toggle-thumb ${isBuilder ? 'lens-toggle-thumb--right' : ''}`}
                aria-hidden="true"
            />
            <button
                type="button"
                className={`lens-toggle-btn ${!isBuilder ? 'active' : ''}`}
                aria-pressed={!isBuilder}
                onClick={() => setLens('strategist')}
            >
                Strategist
            </button>
            <button
                type="button"
                className={`lens-toggle-btn ${isBuilder ? 'active' : ''}`}
                aria-pressed={isBuilder}
                onClick={() => setLens('builder')}
            >
                Builder
            </button>
        </div>
    );
}

export default LensToggle;
